var _defs, _rect, _path, _path2, _path3, _rect2, _path4, _rect3, _path5, _path6, _path7, _path8, _g, _g2, _g3, _path9, _g4, _g5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGiftBoxIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Gift_Box_icon_svg__Illustration",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 840 840",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".Gift_Box_icon_svg__cls-1{fill:#f93444}.Gift_Box_icon_svg__cls-2{fill:#fa505e}.Gift_Box_icon_svg__cls-5{fill:#fd934f}.Gift_Box_icon_svg__cls-6{fill:#fed425}.Gift_Box_icon_svg__cls-7{fill:#e2142d}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "Gift_Box_icon_svg__cls-6",
    x: 213.82,
    y: 394.16,
    width: 412.36,
    height: 295.83,
    rx: 30,
    ry: 30
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "Gift_Box_icon_svg__cls-5",
    d: "M596.18 697.99H243.82c-20.95 0-38-17.05-38-38V424.16c0-20.95 17.05-38 38-38h352.36c20.95 0 38 17.05 38 38v235.83c0 20.95-17.05 38-38 38zM243.82 402.16c-12.13 0-22 9.87-22 22v235.83c0 12.13 9.87 22 22 22h352.36c12.13 0 22-9.87 22-22V424.16c0-12.13-9.87-22-22-22H243.82z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "Gift_Box_icon_svg__cls-5",
    d: "M626.18 542.08V424.17c0-16.57-13.43-30-30-30H243.82c-16.57 0-30 13.43-30 30v117.91h412.36z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "Gift_Box_icon_svg__cls-5",
    d: "M626.18 550.08H213.82c-4.42 0-8-3.58-8-8V424.17c0-20.95 17.05-38 38-38h352.36c20.95 0 38 17.05 38 38v117.91c0 4.42-3.58 8-8 8zm-404.36-16h396.36V424.17c0-12.13-9.87-22-22-22H243.82c-12.13 0-22 9.87-22 22v109.91z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 193.82,
    y: 314.16,
    width: 452.36,
    height: 185.82,
    rx: 30,
    ry: 30,
    fill: "#fcb527"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "Gift_Box_icon_svg__cls-2",
    d: "M616.18 507.98H223.82c-20.95 0-38-17.05-38-38V344.16c0-20.95 17.05-38 38-38h392.36c20.95 0 38 17.05 38 38v125.82c0 20.95-17.05 38-38 38zM223.82 322.16c-12.13 0-22 9.87-22 22v125.82c0 12.13 9.87 22 22 22h392.36c12.13 0 22-9.87 22-22V344.16c0-12.13-9.87-22-22-22H223.82z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "Gift_Box_icon_svg__cls-6",
    x: 193.82,
    y: 244.15,
    width: 452.36,
    height: 185.82,
    rx: 30,
    ry: 30
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "Gift_Box_icon_svg__cls-5",
    d: "M616.18 437.97H223.82c-20.95 0-38-17.05-38-38V274.15c0-20.95 17.05-38 38-38h392.36c20.95 0 38 17.05 38 38v125.82c0 20.95-17.05 38-38 38zM223.82 252.15c-12.13 0-22 9.87-22 22v125.82c0 12.13 9.87 22 22 22h392.36c12.13 0 22-9.87 22-22V274.15c0-12.13-9.87-22-22-22H223.82z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M553.77 437.97H286.23c-4.42 0-8-3.58-8-8s3.58-8 8-8h267.54c4.42 0 8 3.58 8 8s-3.58 8-8 8z",
    fill: "#fff",
    opacity: 0.8
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9697b",
    d: "M372.6 244.15h94.81v185.82H372.6z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "Gift_Box_icon_svg__cls-2",
    d: "M475.4 437.97H364.59V236.15H475.4v201.82zm-94.81-16h78.81V252.15h-78.81v169.82z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "Gift_Box_icon_svg__cls-2",
    d: "M372.6 499.98h94.81v190.01H372.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Gift_Box_icon_svg__cls-1",
    d: "M475.4 697.99H364.59V491.98H475.4v206.01zm-94.81-16h78.81V507.98h-78.81v174.01z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "Gift_Box_icon_svg__cls-7",
    d: "M372.6 499.98h94.81v42.1H372.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Gift_Box_icon_svg__cls-7",
    d: "M475.4 550.08H364.59v-58.1H475.4v58.1zm-94.81-16h78.81v-26.1h-78.81v26.1z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "Gift_Box_icon_svg__cls-2",
    d: "M339.76 370.33c59.82 0 86.3-76.34 38.58-112.42-.58-.44-1.17-.87-1.77-1.3l-43.52-31.06c-28.06-20.03-67.03.03-67.03 34.51v70.27c0 22.09 17.91 40 40 40h33.73z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Gift_Box_icon_svg__cls-1",
    d: "M339.76 378.33h-33.73c-26.47 0-48-21.53-48-48v-70.27c0-18.96 10.47-36.13 27.33-44.81s36.92-7.23 52.35 3.79l43.52 31.06c.66.47 1.3.94 1.94 1.43 24.32 18.39 33.73 49.07 23.97 78.15-9.92 29.55-36.36 48.65-67.38 48.65zm-31.24-152.76c-5.36 0-10.76 1.29-15.84 3.91-11.68 6.01-18.65 17.45-18.65 30.58v70.27c0 17.64 14.36 32 32 32h33.73c24.02 0 44.51-14.81 52.21-37.74 6-17.87 4.3-43.1-18.45-60.3-.52-.39-1.05-.78-1.59-1.17l-43.52-31.06c-6.04-4.31-12.93-6.49-19.89-6.49z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "Gift_Box_icon_svg__cls-2",
    d: "M500.24 370.33c-59.82 0-86.3-76.34-38.58-112.42.58-.44 1.17-.87 1.77-1.3l43.52-31.06c28.06-20.03 67.03.03 67.03 34.51v70.27c0 22.09-17.91 40-40 40h-33.73z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Gift_Box_icon_svg__cls-1",
    d: "M533.97 378.33h-33.73c-31.01 0-57.46-19.1-67.38-48.65-9.76-29.09-.35-59.76 23.97-78.15.64-.48 1.29-.96 1.94-1.43l43.52-31.06c15.43-11.01 35.49-12.46 52.35-3.79 16.86 8.68 27.33 25.85 27.33 44.81v70.27c0 26.47-21.53 48-48 48zm-2.49-152.76c-6.96 0-13.85 2.18-19.89 6.49l-43.52 31.06c-.54.38-1.07.77-1.59 1.17-22.75 17.2-24.44 42.43-18.45 60.3 7.69 22.92 28.18 37.74 52.21 37.74h33.73c17.64 0 32-14.36 32-32v-70.27c0-13.14-6.97-24.57-18.65-30.58-5.08-2.62-10.48-3.91-15.84-3.91z"
  })))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "Gift_Box_icon_svg__cls-1",
    d: "M511.95 326.73H328.06c-4.42 0-8-3.58-8-8s3.58-8 8-8h183.89c4.42 0 8 3.58 8 8s-3.58 8-8 8z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "Gift_Box_icon_svg__cls-2",
    x: 381.5,
    y: 280.23,
    width: 77,
    height: 77,
    rx: 21.2,
    ry: 21.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "Gift_Box_icon_svg__cls-1",
    d: "M437.3 365.23h-34.6c-16.1 0-29.2-13.1-29.2-29.2v-34.6c0-16.1 13.1-29.2 29.2-29.2h34.6c16.1 0 29.2 13.1 29.2 29.2v34.6c0 16.1-13.1 29.2-29.2 29.2zm-34.6-77c-7.28 0-13.2 5.92-13.2 13.2v34.6c0 7.28 5.92 13.2 13.2 13.2h34.6c7.28 0 13.2-5.92 13.2-13.2v-34.6c0-7.28-5.92-13.2-13.2-13.2h-34.6z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "Gift_Box_icon_svg__cls-1",
    d: "M372.6 429.97h94.81v70H372.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Gift_Box_icon_svg__cls-7",
    d: "M475.4 507.98H364.59v-86H475.4v86zm-94.81-16h78.81v-54h-78.81v54z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftBoxIcon);
export default ForwardRef;